import { PATH as ADMIN_TOOLS_PATH } from "./pages/tools/AdminToolsPage";

export const ADMIN_ROUTES = {
  reportDetails: {
    component: () => import("./pages/report/ReportPage"),
    path: "reports/:id",
  },
  listReports: {
    component: () => import("./pages/report/ListReportsPage"),
    path: "reports",
  },
  auditLog: {
    component: () => import("./pages/AuditLogPage"),
    path: "audit",
  },
  aggregateGraph: {
    component: () => import("./aggregate/AggregateGraphPage"),
    path: "aggregate/graph",
  },
  aggregateRange: {
    component: () => import("./aggregate/AggregateRangePage"),
    path: "aggregate/:counter",
  },
  aggregateSnapshot: {
    component: () => import("./aggregate/AggregateSnapshotPage"),
    path: "aggregate",
  },
  tools: {
    component: () => import("./pages/tools/AdminToolsPage"),
    path: ADMIN_TOOLS_PATH,
  },
  root: {
    component: () => import("./pages/LandingPage"),
    path: "",
  },
};
